var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariant99Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_1323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C8.85652 14.5 10.637 13.7625 11.9497 12.4497C13.2625 11.137 14 9.35652 14 7.5C14 5.64348 13.2625 3.86301 11.9497 2.55025C10.637 1.2375 8.85652 0.5 7 0.5C5.14348 0.5 3.36301 1.2375 2.05025 2.55025C0.737498 3.86301 0 5.64348 0 7.5C0 9.35652 0.737498 11.137 2.05025 12.4497C3.36301 13.7625 5.14348 14.5 7 14.5ZM4.78516 5.28516C5.04219 5.02812 5.45781 5.02812 5.71211 5.28516L6.99727 6.57031L8.28242 5.28516C8.53945 5.02812 8.95508 5.02812 9.20937 5.28516C9.46367 5.54219 9.46641 5.95781 9.20937 6.21211L7.92422 7.49727L9.20937 8.78242C9.46641 9.03945 9.46641 9.45508 9.20937 9.70937C8.95234 9.96367 8.53672 9.96641 8.28242 9.70937L6.99727 8.42422L5.71211 9.70937C5.45508 9.96641 5.03945 9.96641 4.78516 9.70937C4.53086 9.45234 4.52812 9.03672 4.78516 8.78242L6.07031 7.49727L4.78516 6.21211C4.52812 5.95508 4.52812 5.53945 4.78516 5.28516Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_1323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant99Black);
export default __webpack_public_path__ + "static/media/variant99-black.8dbaf6f26d71e09a272f7bd1ea8761d6.svg";
export { ForwardRef as ReactComponent };